const routes = [
	// { path: '/', redirect: '/nut-home' },
	{ path: '/', redirect: '/NSwap' },
	{
		path: '/home',
		name: "首页",
		component: () => import('@/view/home/home.vue')
	},
	{
		path: '/swap',
		name: "闪兑",
		component: () => import('@/view/swap/swap.vue')
	},
	{
		path: '/lock',
		name: "ROON锁仓",
		component: () => import('@/view/lock/lock.vue')
	},
	{
		path: '/usdr-swap',
		name: "USDR闪兑",
		component: () => import('@/view/usdr-swap/usdr-swap.vue')
	},
	{
		path: '/me',
		name: "我的",
		component: () => import('@/view/me/me.vue')
	},
    {
        path: '/news-details',
        name: "新闻详情",
        component: () => import('@/view/news-details/news-details.vue')
    },
	{
        path: '/NSwap',
        name: "swap",
        component: () => import('@/view/NewPage/NSwap.vue')
    },
	{
        path: '/Kua',
        name: "Kua",
        component: () => import('@/view/NewPage/Kua.vue')
    },
	{
        path: '/Chi',
        name: "Chi",
        component: () => import('@/view/NewPage/Chi.vue')
    },
	// 新加的页面
	{
	    path: '/roon-mining',
	    name: "ROON Mining",
	    component: () => import('@/view/roon-mining/roon-mining.vue')
	},
	{
	    path: '/add-lp',
	    name: "添加流动性",
	    component: () => import('@/view/add-lp/add-lp.vue')
	},
    {
        path: '/lp-log',
        name: "日志明细",
        component: () => import('@/view/lp-log/lp-log.vue')
    },
	{
	    path: '/my-lp',
	    name: "我的LP",
	    component: () => import('@/view/my-lp/my-lp.vue')
	},
	{
	    path: '/recommender-system',
	    name: "推荐系统",
	    component: () => import('@/view/recommender-system/recommender-system.vue')
	},
	{
	    path: '/dividend-pool',
	    name: "分红池",
	    component: () => import('@/view/dividend-pool/dividend-pool.vue')
	},
	{
	    path: '/nft',
	    name: "NFT权益",
	    component: () => import('@/view/nft/nft.vue')
	},
	{
	    path: '/staking',
	    name: "质押",
	    component: () => import('@/view/staking/staking.vue')
	},
	{
	    path: '/destroy-mining',
	    name: "销毁挖矿",
	    component: () => import('@/view/destroy-mining/destroy-mining.vue')
	},
    {
        path: '/destroy-log',
        name: "日志明细",
        component: () => import('@/view/destroy-mining/log.vue')
    },
	{
	    path: '/destroy-team',
	    name: "我的团队",
	    component: () => import('@/view/destroy-team/destroy-team.vue')
	},
	{
	    path: '/nut-home',
	    name: "nut-首页",
	    component: () => import('@/view/nut-home/nut-home.vue')
	},
	{
	    path: '/nut-reward',
	    name: "nut-奖励",
	    component: () => import('@/view/nut-reward/nut-reward.vue')
	},
	{
	    path: '/nut-introduction',
	    name: "nut-介绍",
	    component: () => import('@/view/nut-introduction/nut-introduction.vue')
	},
	{
	    path: '/nut-reward-pool',
	    name: "nut-奖励池",
	    component: () => import('@/view/nut-reward-pool/nut-reward-pool.vue')
	},

]

export default routes
